import { createFileRoute, redirect } from "@tanstack/react-router";
import { learnBlogSlug } from "@/content/learn/slugs";

// Parent guides moved to /blog; keep old links and rankings via a 301.
export const Route = createFileRoute("/learn/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/blog/$slug",
      params: { slug: learnBlogSlug(params.slug) },
      replace: true,
      statusCode: 301,
    });
  },
});
